import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

interface TooltipWrapperProps {
  id: string;
  title: string;
  place?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactElement;
  className?: string;
}

const GlobalTooltip: React.FC<TooltipWrapperProps> = ({
  id,
  title,
  place = 'top',
  children,
  className,
}) => {
  const childWithTooltip = React.cloneElement(children, {
    'data-tooltip-id': id,
    'data-tooltip-content': title,
    // className: `${children.props.className || ''} ${className || ''}`.trim(),
    className: className,
  });

  return (
    <>
      <span data-tooltip-id={id} data-tooltip-content={title}>
        {children}
      </span>
      {/* {childWithTooltip} */}
      <ReactTooltip
        className={className}
        id={id}
        place={place}
        style={{
          zIndex: 100,
          padding: 5,
          maxWidth: '300px',
          whiteSpace: 'normal',
          position: 'absolute',
        }}
      />
    </>
  );
};

export default GlobalTooltip;
